<template>
  <div class="container">
    <div class="row g-4">
      <div class="col-md-3">
        <div class="row">
          <div class="col-md-12">
            <img src="funding.png" class="img-fluid" alt="SSHRC CRSH Canada" />
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <div class="card mt-4 mb-5 m-2">
          <h5 class="card-header">Grants</h5>
          <div class="card-body">
            <h5 class="card-title">Graham & Gale Distinguished Researcher Award, 2023</h5>
            <p class="card-text">Awarded by the Faculty of Arts & Humanities ($5,000).</p>

            <h5 class="card-title">SSHRC Reapplication Assistance Program, 2022</h5>
            <p class="card-text">
              Multimodal heritage speech learning: The case of Spanish, CAD$4,992. PI: Rafat, Co-investigators:
              Stevenson, and Joanisse, (collaborator).
            </p>

            <h5 class="card-title">SSHRC Partnership Grant (stage 1), 2022</h5>
            <p class="card-text">
              Examining facilitators of and barriers to bilingualism among newcomers to Canada, CAD$20,000. PI:
              Schwieter (director), Gottardo (co-director), and Libben (co-director). Co-investigators: Rafat, Fennell,
              Molnar, Ramirez, Sabourin, Sorace, Titone, Whitford, Wood.
            </p>

            <h5 class="card-title">SSHRC Insight Grant, 2022</h5>
            <p class="card-text">
              The differential contribution of auditory, visual articulatory gestures and orthographic input to
              perceptual learning in early vs, late bilinguals, CAD$83,773. PI: Rafat. Co-investigators: Stevenson and
              Joanisse.
            </p>

            <h5 class="card-title">WSS SHRC, 2022</h5>
            <p class="card-text">
              The differential contribution of auditory visual articulatory gestures and orthographic input to
              perceptual learning in early vs. late bilinguals, CAD$24,800. PI: Rafat.
            </p>

            <h5 class="card-title">University of Western Ontario Deans’ Travel-Research Grants, 2021</h5>
            <p class="card-text">CAD$1,600. PI: Rafat.</p>

            <h5 class="card-title">FRDF, 2020-2021</h5>
            <p class="card-text">How does language experience shape perceptual learning, CAD$6,948. PI: Rafat.</p>

            <h5 class="card-title">Western University, 2015-present</h5>
            <p class="card-text">Speaker Series Award: L2 Speech Learning Research Group, CAD$500. PI: Rafat.</p>

            <h5 class="card-title">SSHRC Partnership Engage Grant, 2020-2021</h5>
            <p class="card-text">
              How handwriting and typewriting may help or hinder second language learning, CAD$25,000. PI: Rafat.
              Co-investigator: Joanisse.
            </p>

            <h5 class="card-title">FRDF Travel Grant</h5>
            <p class="card-text">
              Language plasticity over the lifespan: A longitudinal study of first language change in Farsi-English
              bilinguals, CAD$3,500. PI: Rafat.
            </p>

            <h5 class="card-title">French Embassy Franco-Canadian Initiative Grant, 2019-2020</h5>
            <p class="card-text">
              The Canadian Linguistics special session on L2 speech learning, CAD$2,500. PI: Rafat.
            </p>

            <h5 class="card-title">University of Western Ontario Deans’ Travel Research Grant, 2018</h5>
            <p class="card-text">CAD$900. PI: Rafat.</p>

            <h5 class="card-title">UWO, 2017-2018, Faculty Research Development Funding</h5>
            <p class="card-text">CAD$2,500. PI: Rafat.</p>

            <h5 class="card-title">The Canadian Ethnic Speech Database, 2017-2018</h5>
            <p class="card-text">CAD$6,000. PI: Rafat.</p>

            <h5 class="card-title">SSHRC Insight Development Grant</h5>
            <p class="card-text">
              Second language speech production, processing, and reading of highly proficient bilinguals living in
              Canada: What does orthography have to do with it? CAD$67,286. PI: Rafat. Co-investigator: Joanisse.
            </p>

            <h5 class="card-title">SSHRC Seed Grant, 2016-2017</h5>
            <p class="card-text">The Canadian Multilingual Speech Database, CAD$23,000. PI: Rafat.</p>

            <h5 class="card-title">FRDF Travel Grant, 2016-2017</h5>
            <p class="card-text">
              Investigating the bilingual advantage in the imitation of Sussex English intonation: Evidence from Quebec
              French-English bilinguals and English monolinguals, CAD$845.23. PI: Rafat.
            </p>

            <h5 class="card-title">FRDF Research Grant, 2016-2017</h5>
            <p class="card-text">
              The Canadian Ethnic Speech Database, CAD$6,000. PI: Rafat. Co-investigators: Karamichalis.
            </p>

            <h5 class="card-title">University of Western Ontario Deans’ Travel Research Grant, 2016</h5>
            <p class="card-text">CAD$1,082.83. PI: Rafat.</p>

            <h5 class="card-title">SSHRC (SSHRB) Seed Grant, 2015-present</h5>
            <p class="card-text">
              Learning to read in a foreign context: the interaction of change of first and second language reading
              strategies, CAD$14,857. PI: Rafat. Co-investigators: Joanisse and Pobric.
            </p>

            <h5 class="card-title">SSHRC Insight Development Grant, 2015-2016</h5>
            <p class="card-text">
              Second language speech production, processing, and reading of highly proficient bilinguals living in
              Canada: what does orthography have to do with it? CAD$5,000. PI: Rafat. Co-investigators: Joanisse.
            </p>

            <h5 class="card-title">University of Western Ontario Deans’ Travel Research Grant, 2015</h5>
            <p class="card-text">CAD$1,300. PI: Rafat.</p>

            <h5 class="card-title">SSHRC Insight Development Grant, 2014-2015</h5>
            <p class="card-text">
              Second language speech production, processing, and reading of highly proficient bilinguals living in
              Canada: What does orthography have to do with it? CAD$5,000. PI: Rafat. Co-investigators: Joanisse.
            </p>

            <h5 class="card-title">UWO Faculty Research Development Funding, 2014-2015</h5>
            <p class="card-text">
              Orthographic effects in the second language speech of highly proficient bilinguals, CAD$6,202. PI: Rafat.
            </p>

            <h5 class="card-title">University of Western Ontario Deans’ Travel Research Grant, 2014</h5>
            <p class="card-text">CAD$1,107.65. PI: Rafat.</p>

            <h5 class="card-title">UWO Small Academic Development Fund, 2012-2013</h5>
            <p class="card-text">
              Attrition in geminates in the Iranian Canadian community: Across three generations? CAD$6,000. PI: Rafat.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
